import { createAsyncThunk } from '@reduxjs/toolkit';
import type { CiterneAffectation } from '@/types';
import api from '@/api/client';
import { parsePaginatedResponse } from '@/api/types';
import { setAffectations, editAffectation, removeAffectation } from '../slices/affectationSlice';
import { setToast } from '../slices/toastSlice';

export const fetchAffectations = createAsyncThunk<void, number | undefined>(
  'affectation/fetch',
  async (pageNo, { dispatch, rejectWithValue }) => {
    const page = pageNo ?? 0;
    try {
      const { data } = await api.get(
        '/citernes/affectations',
        { params: { pageNo: page, pageSize: 10 } }
      );


      console.log('data', data);
      const { list, pageNum, totalPages } = parsePaginatedResponse<CiterneAffectation>(data);
      dispatch(setAffectations({ data: list, pageNum, totalPages }));
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erreur chargement affectations';
      dispatch(setToast({ message, severity: 'error' }));
      return rejectWithValue(message);
    }
  }
);

export const createAffectation = createAsyncThunk<
  boolean,
  Partial<CiterneAffectation> & { citerne?: { id: number }; chantier?: { id: number }; date_d?: string; date_f?: string },
  { rejectValue: string }
>('affectation/create', async (payload, { dispatch, rejectWithValue }) => {
  try {
    await api.post('/citernes/affectations', payload);
    await dispatch(fetchAffectations());
    dispatch(setToast({ message: 'Affectation créée', severity: 'success' }));
    return true;
  } catch (err: unknown) {
    const message = err instanceof Error ? err.message : 'Erreur création';
    dispatch(setToast({ message, severity: 'error' }));
    return rejectWithValue(message);
  }
});

export const updateAffectation = createAsyncThunk<boolean, CiterneAffectation, { rejectValue: string }>(
  'affectation/update',
  async (affectation, { dispatch, rejectWithValue }) => {
    try {
      await api.put(`/citernes/affectations/${affectation.id}`, affectation);
      dispatch(editAffectation(affectation));
      dispatch(setToast({ message: 'Affectation modifiée', severity: 'success' }));
      return true;
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erreur modification';
      dispatch(setToast({ message, severity: 'error' }));
      return rejectWithValue(message);
    }
  }
);

export const deleteAffectation = createAsyncThunk<boolean, CiterneAffectation, { rejectValue: string }>(
  'affectation/delete',
  async (affectation, { dispatch, rejectWithValue }) => {
    try {
      await api.delete(`/citernes/affectations/${affectation.id}`);
      dispatch(removeAffectation(affectation));
      dispatch(setToast({ message: 'Affectation supprimée', severity: 'success' }));
      return true;
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erreur suppression';
      dispatch(setToast({ message, severity: 'error' }));
      return rejectWithValue(message);
    }
  }
);
